import styled from "styled-components";
import { color } from "../../resources";

export const Container = styled.div<{
  children: JSX.Element;
}>`
  width: 100%;
  height: 100%;
  background-color: ${color.background};
  align-items: center;
  justify-content: center;
  display: flex;
`;
